import { SOCKET_URL } from './networkEndpoints';
import { prepareUserCenterReturn, clearUserCenterSession } from './userCenterSession';
import { io } from 'socket.io-client';
import store from '../store';
import { switchState } from '../slices/stateSlice';
import { SiteState } from '../enums';
import { clearScene } from '../slices/sceneSlice';
import { LoadState, setLoadState } from '../slices/accountSlice';
import { batch } from 'react-redux';
import {appConnectionStatus,isBundledClient} from './appConnectionStatus';
import {endFight} from '../slices/fightSlice';
import { isMobileGameDevice } from '../hooks/useMobileGameViewport';

const native=isBundledClient();
let intentional=false;

const socket = io(SOCKET_URL as string, {
  auth: {
    token: '',
    mobile: isMobileGameDevice(),
  },
  autoConnect: false,
  reconnectionAttempts: native?5:3,
  ...(native?{timeout:6000,reconnectionDelay:1000,reconnectionDelayMax:3000}:{}),
});

const stopRecovery=()=>{socket.io.reconnection(false);socket.sendBuffer=[];socket.disconnect();};
const failRecovery=()=>{appConnectionStatus.fail();stopRecovery();};
socket.on('authFailed', () => {localStorage.removeItem('jwt');if(native){intentional=true;failRecovery();}});
socket.on('connect', () => {
  console.log('Connected to the game server.');
});
socket.on('disconnect', (reason) => {
  console.log('Disconnected from game server.');
  if(native&&!intentional){
    if(appConnectionStatus.get()==='failed')return;
    socket.sendBuffer=[];
    if(reason==='io server disconnect'){failRecovery();return;}
    appConnectionStatus.retry();appConnectionStatus.watch(stopRecovery);
    batch(()=>{
      store.dispatch(endFight());store.dispatch(clearScene());
      store.dispatch(setLoadState(LoadState.NOT_LOADED));
      store.dispatch(switchState(SiteState.GAME_LOADER));
    });
    return;
  }
  batch(() => {
    store.dispatch(clearScene());
    store.dispatch(switchState(SiteState.LANDING));
    store.dispatch(setLoadState(LoadState.NOT_LOADED));
  });
});
if(native){
 socket.on('connect_error',()=>{if(!intentional&&appConnectionStatus.get()!=='failed'){appConnectionStatus.retry();appConnectionStatus.watch(stopRecovery);}});
 socket.io.on('reconnect_attempt',()=>{if(!intentional)appConnectionStatus.retry();});
 socket.io.on('reconnect_failed',()=>{if(!intentional)failRecovery();});
}
// socket.onAny((event, ...args) => {
//   console.log(`got ${event}`);
// });

export function connectWithJWT(jwt: string) {
  if(native){
    intentional=false;socket.io.reconnection(true);appConnectionStatus.watch(stopRecovery);
    if(appConnectionStatus.get()==='reconnecting'&&socket.active)return;
  }
  // @ts-ignore
  socket.auth.token = jwt;
  socket.connect();
}

export function logOff(returnToCenter=false) {
  if(native){intentional=true;appConnectionStatus.reset();socket.sendBuffer=[];}
  if(returnToCenter)prepareUserCenterReturn();else clearUserCenterSession();
  localStorage.removeItem('jwt');
  socket.disconnect();
}

export const toServer = (event: string, data: any = null, cb: (...args: any[]) => void = () => {}) => {
  if(native&&!socket.connected)return socket;
  return socket.emit(event, data, cb);
};
export const fromServer = (event: string, cb: (...args: any[]) => void) => socket.on(event, cb);
export const cancelFromServer = (event: string, cb?: (...args: any[]) => void) => socket.off(event, cb);
